import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { MessageCircle, Clock } from "lucide-react";
import { dayName, colorOf, fmtRange, waLink, GOLD } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const ClassDialog = ({ cls, onClose, content }) => {
  const { t, lang, pick } = useLang();
  const c = colorOf(cls?.color);
  const isDil = cls?.program === "dillusions";
  const p = content.pricing;
  const cur = pick(p, "currency");
  const fee = isDil ? `${p.monthly_fee} ${cur} ${t.perMonth}` : pick(cls, "fee") || t.contactUs;
  const msg = isDil ? t.waTrial(pick(cls, "title")) : t.waAsk(pick(cls, "title"), pick(cls, "style"));
  return (
    <Dialog open={!!cls} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir={lang === "ar" ? "rtl" : "ltr"} data-lenis-prevent className="max-h-[92vh] max-w-md overflow-y-auto overflow-x-hidden border-white/10 bg-[#101017] p-0 text-white" data-testid="class-dialog">
        {cls && (
          <>
            {cls.image && (
              <div className="relative flex justify-center overflow-hidden bg-black" data-testid="class-dialog-image">
                <img src={cls.image} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-40 blur-2xl" />
                <img src={cls.image} alt={pick(cls, "title")} decoding="async" className="relative max-h-[58vh] w-auto max-w-full object-contain" />
              </div>
            )}
            <div className="space-y-5 px-6 pb-6 pt-5">
              <span className="inline-block rounded-full px-3 py-1 font-mono text-[11px] font-bold uppercase text-black" style={{ background: isDil ? c : GOLD }}>
                {isDil ? t.dillusions : t.specialty}
              </span>
              <div>
                <DialogTitle className="font-display text-3xl font-bold uppercase tracking-tight">{pick(cls, "title")}</DialogTitle>
                <DialogDescription className="mt-1 text-zinc-300">{pick(cls, "style")}{cls.tag ? ` · ${pick(cls, "tag")}` : ""}{cls.ages ? ` · ${pick(cls, "ages")}` : ""}</DialogDescription>
              </div>
              <ul className="space-y-2" data-testid="class-dialog-sessions">
                {cls.sessions.length ? cls.sessions.map((s, i) => (
                  <li key={i} className="flex items-center justify-between rounded-lg border border-white/[0.08] px-4 py-2.5">
                    <span className="flex items-center gap-2 text-sm"><Clock size={14} style={{ color: c }} />{dayName(s.day, lang)}</span>
                    <span className="font-mono text-sm text-zinc-200">{fmtRange(s, lang)}</span>
                  </li>
                )) : <li className="rounded-lg border border-dashed border-white/10 px-4 py-2.5 text-sm text-zinc-300">{t.scheduleTba}</li>}
              </ul>
              <div className="flex items-end justify-between border-t border-white/[0.08] pt-4">
                <div>
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{t.monthlyFee}</span>
                  <p className="font-display text-2xl font-bold" data-testid="class-dialog-fee">{fee}</p>
                </div>
                {isDil && p.free_trial > 0 && <span className="rounded-full border border-accent/40 px-3 py-1 text-xs text-accent">{t.freeTrialBadge(p.free_trial)}</span>}
              </div>
              <a href={waLink(content.contact, msg)} target="_blank" rel="noreferrer" data-testid="class-dialog-whatsapp-btn"
                className="flex w-full items-center justify-center gap-2 rounded-full bg-accent py-3.5 font-bold text-onaccent transition-transform hover:-translate-y-0.5">
                <MessageCircle size={18} /> {isDil ? t.bookOnWa : t.enquireOnWa}
              </a>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
